import { IconFavorite } from "app/components/Icon/Icon";
import isPublicView from "app/utils/publicViewUtils";
import React from "react";

type Props = {
  liveEvents: any;
  favouriteSelected: boolean;
  addRemoveFavourite: (...args: Array<any>) => any;
};

const AsianEventIconsLiveEvents: React.FC<Props> = props => {
  const { liveEvents, addRemoveFavourite, favouriteSelected } = props;

  return (
    <div className="asian-event__icons-col">
      {liveEvents}
      <span>
        <span
          className={`favourites-icon ${isPublicView() ? "disabled" : ""}`}
          onClick={addRemoveFavourite}
        >
          <IconFavorite
            className={`asian-event__event-favorite-icon icon--${
              favouriteSelected ? "active" : ""
            }`}
          />
        </span>
      </span>
    </div>
  );
};

export default AsianEventIconsLiveEvents;
